 
import { getID } from "src/libs/utilities";
import { LANDING_TYPE_CONTENT } from "../interfaces";

export default function logo():any[] {
    return [
        {
            "id": getID("logo"),
            "type": LANDING_TYPE_CONTENT.LOGO,
            "src": "/assets/img/landing/examples/atka-little.logo.svg",
            "title": "Траектория — Камчатка",
            "description": "Траектория будущего / Этапы пути",
            "commentary": "Министерство образования Камчатского края",
            "link_url": "https://kam-life-pro.ru",
            "horizontal_align": "middle",
            "titleStyle": {
                "fontWeight": 100, 
                "padding": "10px 0 15px 0",
                "lineHeight": 0.9,
                "fontSize": 50, 
                "backgroundPosition": "center center",
                "borderColor": "transparent",
                "borderStyle": "solid"
            },
            "wrapped": true,
            "width": 80,
            "height": 80,
            "style": { "margin": 30 },
            "dimentions": {
                "300": {
                "data": {
                    "titleStyle": { "fontSize": 20 },
                    "descriptionStyle": { "fontSize": 11 },
                    "commentaryStyle": { "fontSize": 9 }
                }
                },
                "768": {
                "style": { "fontSize": 16 },
                "data": {
                    "titleStyle": { "fontSize": 20 },
                    "descriptionStyle": { "fontSize": 11 },
                    "commentaryStyle": { "fontSize": 9 }
                }
                }
            },
            defaultTitle: "Логотип в строку",
            defaultDescription: "Большой логотип с девизом и описанием."
        },
        {
            "id":  getID("logo"),
            "type": LANDING_TYPE_CONTENT.LOGO,
            "src": "/assets/img/landing/examples/logo_kraefest_full.svg",
            "title": "",
            "description": "Думай глобально. Действуйт локально.",
            "commentary": "Сеть образовательных фестивалей",
            "link_url": "https://kam-life-pro.ru",
            "horizontal_align": "middle",
            "vertical": true,
            "titleStyle": {
                "fontWeight": 100, 
                "padding": "10px 0 15px 0",
                "lineHeight": 0.9,
                "fontSize": 50, 
                "backgroundPosition": "center center",
                "borderColor": "transparent",
                "borderStyle": "solid"
            },
            "commentaryStyle": {
                "fontSize": 12,
                "letterSpacing": 4
            },
            "wrapped": true, 
            "height": 80,
            "style": { "margin": 30 },
            "dimentions": {
                "300": {
                "data": {
                    "titleStyle": { "fontSize": 20 },
                    "descriptionStyle": { "fontSize": 11 },
                    "commentaryStyle": { "fontSize": 9 }
                }
                },
                "768": {
                    "style": { "fontSize": 16 },
                    "data": {
                        "titleStyle": { "fontSize": 20 },
                        "descriptionStyle": { "fontSize": 11 },
                        "commentaryStyle": { "fontSize": 9 }
                    }
                }
            },
            defaultTitle: "Логотип в колонку",
            defaultDescription: "Большой логотип с девизом и описанием. Отлично подойдёт для вертикальных или пропорциональных лого."
        }
    ]
}